import CookingGameList from './CookingGameList.vue';
import CookingGame from './CookingGame.vue';

export default {
  CookingGameList,
  CookingGame,
};
